export const getApiUrl = () => window.dashenvs["BACKEND_HOST"]; //process.env.REACT_APP_BACKEND_HOST;
